import { JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { ResponcePage } from 'projects/core/src/lib/misc/data/responce-page';
import { ProjectAlert } from './alert';

@JsonObject('AlertResponcePage')
export class AlertResponcePage extends ResponcePage {

    @JsonProperty([ProjectAlert], 'content')
    content: ProjectAlert[];
}